"use client";
import useTranslate from "@app/_hooks/useTranslate";
import { envConfig } from "@/config/env";
import AddToCart from "@components/AddToCart";
import { CarouselDotsNavigation } from "@components/Carousel";
import ProductCard from "@components/ProductCard";
import type { CartItem } from "@server/gql/graphql";
import { useMemo } from "react";
import type { Variant } from "types/product";
import { type Product } from "types/product";
import { useCheckout, useCheckoutContext } from "./Checkout.hooks";

function mapItemToVariant(item: CartItem): Variant {
  return {
    id: item.partNo,
    type: "Variant",
    title: item.name,
    images: [],
    image: {
      src: `${envConfig.NEXT_PUBLIC_NORCE_IMAGE_CDN}/${item.imageKey}?w=200&h=200&mode=max`,
      id: "asd",
      type: "image",
      alt: "asd",
    },
    groupId: item.partNo,
    price: item.price,
    ImageURL: "",
    stock: true,
    deliveryMin: 0,
    deliveryMax: 0,
    deliveryUnit: "",
    stockStatus: "",
    stockQuantity: 1,
    VariantDefiningAttributes: "",
    norce_color: "",
    norce_variant: "",
    campaignPrice: true,
    originalPrice: item.priceOriginal,
    articleStatus: "",
  };
}
function mapItemToProduct(item: CartItem): Product {
  return {
    type: "Product",
    id: item.partNo,
    productCode: "",
    slug: "",
    title: item.name,
    brand: "",
    price: item.price,
    images: [
      {
        src: `${envConfig.NEXT_PUBLIC_NORCE_IMAGE_CDN}/${item.imageKey}?w=200&h=200&mode=max`,
        id: "asd",
        type: "image",
        alt: "asd",
      },
    ],
    groupId: item.partNo,
    description: "",
    category: "",
    hasVariants: false,
    stockStatus: "",
    variantAttributes: [],
    campaignPrice: true,
    originalPrice: item.priceOriginal,
    variant: mapItemToVariant(item),
    articleStatus: "",
  };
}

/**
 *
 * @todo Refactor this component. It's a mess.
 */
export default function Offers() {
  const t = useTranslate();
  useCheckoutContext();
  const { data } = useCheckout();

  const offers = useMemo(() => {
    const items: CartItem[] = [];
    if (!data?.items.length) return [];
    for (const item of data.items) {
      if (item.optionalItems?.length) {
        items.push(...item.optionalItems);
      }
    }
    return items.map(mapItemToProduct);
  }, [data]);

  if (!offers.length) return null;

  return (
    <div className="border-t border-grey-150 pb-6 pt-6 md:pt-7 lg:pb-3">
      <div className="mb-4 px-4 md:mb-6">
        <p className="text-lg">{t("offers")}</p>
        <p className="mt-0.5 text-base md:mt-2">{t("offersText")}</p>
      </div>
      <CarouselDotsNavigation
        hideNavigation={false}
        classNames={{
          wrapper: "px-0",
          slider:
            "[--gap:1px] [--slides-per-view:2.2] sm:[--slides-per-view:4] lg:[--slides-per-view:5] child:min-w-0 scrollbar-none",
        }}
      >
        {offers.map((product) => (
          <ProductCard.Root isDense key={product.id} product={product}>
            <ProductCard.Link>
              <ProductCard.Image />
              <ProductCard.Content>
                <ProductCard.Brand />
                <ProductCard.Title />
                <ProductCard.Price />
              </ProductCard.Content>
            </ProductCard.Link>
            <AddToCart
              product={product}
              variant={product.variant}
              classNames={{
                form: "px-2",
                button: "btn-outlined",
                buttonAdded: "btn-primary",
              }}
              buttonText={t("add")}
              buttonTextAdded={t("added")}
            />
          </ProductCard.Root>
        ))}
      </CarouselDotsNavigation>
    </div>
  );
}
